export const BRAND = {
  name: 'Flow',
  legalEntity: 'Ballee Sàrl',
  tagline: 'The Artist Management Platform',
  team: 'Flow Team',
  systemUsers: { support: 'Flow Support', notifications: 'Flow' },
  logos: {
    svg: '/flow-fmark.svg',
    emailPng: 'https://flow.ballee.app/images/flow-logo-email.png',
  },
  emails: {
    // Senders must sit on a Resend-verified domain. ballee.app is not one:
    // a send from that domain is refused with 403 (measured 2026-09-19).
    noreply: 'Flow <noreply@notifications.ballee.co>',
    notifications: 'Flow <noreply@notifications.ballee.co>',
    // The two addresses a person can write to. Both are Workspace groups.
    // Retired: info@, contact@, press@, engineering@ (kept only as Workspace
    // aliases, so mail to an address already printed somewhere still arrives).
    support: 'support@ballee.co',
    admin: 'admin@ballee.co',
  },
  social: { twitter: '@balleeapp' },
  urls: { app: 'ballee.app', website: 'ballee.co' },
  documents: {
    productionServices: 'Flow Production Services',
    footer: 'Flow | ballee.app | support@ballee.co',
  },
  company: {
    legalName: 'Ballee Sàrl',
    address: {
      street: '2, Rue Caroline',
      postalCode: '1003',
      city: 'Lausanne',
      country: 'Switzerland',
    },
    email: 'support@ballee.co',
    registrationNumber: 'CH550.1.241.695-3',
    bank: {
      beneficiary: 'Ballee Sàrl',
      iban: 'CH910024324363618101W',
      swift: 'UBSWCHZH80A',
      beneficiaryAddress: 'Rue Caroline 2, 1003, Lausanne, Switzerland',
      bankName: 'UBS SWITZERLAND AG',
      bankAddress: 'Bahnhofstrasse 45, Zürich, Switzerland',
    },
  },
} as const;
